import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import CertificationForm from "../components/CertificationForm";

export default class CertificationStep extends TalentAppStep {
    static path = '/certification';
    static LastUpdatedMethod = 'lastUpdatedEducation';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = 'Certifications';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'Highlight the certifications you’ve earned.';
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.education.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Resume';
    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;
    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.certifications?.length} Certifications`;
    };

    static hasCompleted(user) {
        // let items = TB.pick(user, ['certifications']);
        //
        // items = TB.flatten(TB.values(items));
        //
        // items = TB.filter(items, item => TB.isDefined(item?.name))
        //
        // return items.length > 0;
        return true
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateCertifications()
    };


    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {

        return (
            <div className="pb-6">

                <div>
                    {this.renderChildForm({
                        displayName: TB.trans('talent.education.certification_display_name'),
                        ChildFormComponent: CertificationForm,
                        userProp: 'certifications'
                    })}
                </div>

            </div>
        );
    }

    /**
     * Are requirements optional?
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return true;
    }

    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'Certifications are optional and not required.';
    }
}